import { Action } from "../../models/action";
import * as types from "../../constants";
import { DialogAction } from "../../models/dialog-actions";

export interface ISectorsState {
  sectors: any[];
  isLoading: boolean;
  totalDocs: number;
  lastDoc?: any;
  error?: string;
  dialog: {
    isDialogOpen: boolean;
    isDialogLoading: boolean;
    dialogAction: DialogAction;
    selectedSector?: any;
  };
}

const initialState = {
  sectors: [],
  isLoading: false,
  totalDocs: 0,
  dialog: {
    isDialogOpen: false,
    isDialogLoading: false,
    dialogAction: DialogAction.Initial,
  },
} as ISectorsState;

export const sectorsReducer = (
  state = initialState,
  action: Action
): ISectorsState => {
  switch (action.type) {
    case types.SECTORS_GET_DOCS:
      return {
        ...state,
        sectors: action.payload,
      };
    case types.SECTORS_UPDATE_DOC:
      return {
        ...state,
        sectors: state.sectors.map((x) =>
          x.id === action.payload.id ? { ...x, ...action.payload } : x
        ),
      };
    case types.SECTORS_REMOVE_DOC:
      return {
        ...state,
        sectors: state.sectors.filter((x) => x.id !== action.payload.id),
      };
    case types.SECTORS_ADD_DOCS:
      return {
        ...state,
        sectors: [...state.sectors, ...action.payload],
      };
    case types.SECTORS_SET_LAST_DOC:
      return {
        ...state,
        lastDoc: action.payload,
      };
    case types.SECTORS_SET_TOTAL_DOCS:
      return {
        ...state,
        totalDocs: action.payload,
      };
    case types.SECTORS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case types.SECTORS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case types.SECTORS_IS_DIALOG_OPEN:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isDialogOpen: action.payload,
        },
      };
    case types.SECTORS_IS_DIALOG_LOADING:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isDialogLoading: action.payload,
        },
      };
    case types.SECTORS_CHANGE_DIALOG_ACTION:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          dialogAction: action.payload,
        },
      };
    case types.SECTORS_SET_SELECTED_SECTOR:
      return {
        ...state,
        dialog: {
          ...state.dialog,
          selectedSector: action.payload,
        },
      };
    default:
      return state;
  }
};
